import React, { ReactChild, useState } from 'react';
import { HaierCostingStatus } from 'views/Costing/common/model/haierCostingStatus.model';

export interface ParcelCostingDetailType {
  costingId: string;
  costingNumber: string | null;
  costingStatus: HaierCostingStatus | null;
  jobNumber: string | null;
  isLoading: boolean;
  backUrl: string;
  editRequest: boolean;
  modalConfirmChecked: {
    costingNumber: string | null;
    refNumber: string | null;
    totalAfterDiscount: number;
    totalAfterDiscountSale: number;
  };
  modalConfirmReject: {
    costingNumber: string | null;
    grandTotalPrice: number;
    grandTotalPriceSale: number;
  };
}

interface ParcelCosting {
  selectedCostingDetail: ParcelCostingDetailType;
  setSelectedCostingDetail: (
    params: (cb: ParcelCostingDetailType) => ParcelCostingDetailType,
  ) => void;
}

const HaierCostingContext = React.createContext({} as ParcelCosting);

type ParcelCostingProps = {
  children: ReactChild;
};

const HaierCostingProvider: React.FC<ParcelCostingProps> = (props) => {
  const { children } = props;
  const [selectedCostingDetail, setSelectedCostingDetail] = useState<ParcelCostingDetailType>({
    costingId: '',
    costingNumber: null,
    costingStatus: null,
    jobNumber: null,
    isLoading: true,
    backUrl: '',
    editRequest: false,
    modalConfirmChecked: {
      costingNumber: null,
      refNumber: null,
      totalAfterDiscount: 0,
      totalAfterDiscountSale: 0,
    },
    modalConfirmReject: {
      costingNumber: null,
      grandTotalPrice: 0,
      grandTotalPriceSale: 0,
    },
  });

  const store = {
    selectedCostingDetail,
    setSelectedCostingDetail,
  };

  return <HaierCostingContext.Provider value={store}>{children}</HaierCostingContext.Provider>;
};

export { HaierCostingContext, HaierCostingProvider };
